import { VisitEncounterMode } from '@dreryk/egabinet-visit-frontend-api';

import { MapMarkerIcon, StyledFlex, VideoConsultationIcon } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { visitTranslationKeys } from '../../translations';

import { visitEncounterModeVisitor } from './VisitEncounterModeText.utils';
import { VisitEncounterModeIcon } from './VisitEncounterModeIcon';

const t = visitTranslationKeys.controlsBar.visitEncounterMode;

type VisitEncounterModeTextProps = {
   visitEncounterMode: VisitEncounterMode;
};

export const VisitEncounterModeText = (props: VisitEncounterModeTextProps): JSX.Element | null => {
   const { icon, label } = visitEncounterModeVisitor(props.visitEncounterMode)({
      asOnSite: () => ({
         icon: <MapMarkerIcon />,
         label: t.ON_SITE,
      }),
      asVideoConsultation: () => ({
         icon: <VideoConsultationIcon />,
         label: t.VIDEO_CONSULTATION,
      }),
   });

   return (
      <StyledFlex alignItems={'center'}>
         <VisitEncounterModeIcon icon={icon} />
         <Translate>{label}</Translate>
      </StyledFlex>
   );
};
